module.exports = __webpack_public_path__ + "static/media/How to create contracts with dig. signature and get my client sign it digitally.3f9f1577.png";